import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import ContactInfo from "./components/ContactInfo";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import PolicyInformation from "../guest-user/claim-creation";
import ClaimStatus from "../claim-status";
import AboutUs from "../about-us";
import { useAuthStore } from "../../store/useAuthStore";
import { useNavigate } from "react-router-dom";

export default function WelcomePage() {
  const [selectedNav, setSelectedNav] = useState("home");
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const renderContent = () => {
    switch (selectedNav) {
      case "home":
        return <HeroSection onNavClick={setSelectedNav} />;
      case "claimStatus":
        return <ClaimStatus />;
      case "aboutUs":
        return <AboutUs />;
      case "DEATH":
        return <PolicyInformation onSubmit={() => {}} />;
      case "TEN_PERCENT":
        return <PolicyInformation onSubmit={() => {}} />;
      default:
        return null;
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <ContactInfo />
      <Header onNavClick={setSelectedNav} />
      <Box sx={{ flex: 1, overflow: "auto" }}>{renderContent()}</Box>
    </Box>
  );
}
